module.exports = __webpack_public_path__ + "img/sec2_05.4d70b641.png";